module.exports = __webpack_public_path__ + "static/media/nav-icon-favorites.96c878ff.svg";